/* STEP 11d · lane D1b (owner card V3, 01-Nov-2026) — EN + AR of
   A3 the associate disposal proceeds on a trial-balance cash flow (IFRSCashFlowTbInputs; the gap itself is named by the server);
   A6 the W9 amount typed with a required reason, and the confirm before the lines replace it (W9AmountCell, lib/api.js);
   A8 the restatement Emphasis of Matter: decline / offer again (RestatementEomSuggest);
   A9 "Send to misstatements" saves a changed row first (lib/saveThenSend.js).
   No standard paragraph is quoted. */
const I18N_S11D1B = {
  en: {
    s11d1b: {
      assoc: {
        disposalHint: "The investment in associates fell by more than the share of profit and the figures entered explain: enter the cash received from the disposal.",
      },
      amount: {
        edit: "Edit amount",
        newAmount: "New amount",
        reason: "Reason for the change (required)",
        save: "Save amount",
        cancel: "Cancel",
        saved: "Amount saved — the reason and the old amount are in the Audit Trail.",
        reasonRequired: "Give the reason for changing the amount.",
        typed: "Typed amount (was {from}) — {reason} · {by} · {at}",
        confirmTitle: "Replace the typed amount?",
        confirmOk: "Replace",
        kept: "Not changed — the typed amount is kept.",
      },
      eom: {
        decline: "Decline",
        declinePrompt: "Decline the Emphasis of Matter for the restatement? You may give a reason (optional).",
        declined: "Emphasis of Matter for the restatement declined by {by} on {at}.",
        declinedReason: "Reason: {reason}",
        offerAgain: "Offer again",
        declinedToast: "Declined — the warning is removed. It comes back if the restatement entries change.",
        noteNamed: "Note {n} — {title}",
      },
      send: {
        saveFailed: "The row was not saved, so it was not sent: {msg}",
        savingFirst: "Saving the row first…",
      },
    },
  },
  ar: {
    s11d1b: {
      assoc: {
        disposalHint: "انخفض الاستثمار في الشركات الزميلة بأكثر مما تفسّره الحصة من الأرباح والأرقام المدخلة: أدخل النقد المقبوض من الاستبعاد.",
      },
      amount: {
        edit: "تعديل المبلغ",
        newAmount: "المبلغ الجديد",
        reason: "سبب التغيير (مطلوب)",
        save: "حفظ المبلغ",
        cancel: "إلغاء",
        saved: "حُفظ المبلغ — السبب والمبلغ السابق في سجل التدقيق.",
        reasonRequired: "اذكر سبب تغيير المبلغ.",
        typed: "مبلغ مُدخل يدويًا (كان {from}) — {reason} · {by} · {at}",
        confirmTitle: "استبدال المبلغ المُدخل يدويًا؟",
        confirmOk: "استبدال",
        kept: "لم يتغيّر شيء — بقي المبلغ المُدخل يدويًا.",
      },
      eom: {
        decline: "رفض",
        declinePrompt: "رفض فقرة لفت الانتباه الخاصة بإعادة العرض؟ يمكنك ذكر السبب (اختياري).",
        declined: "رفض {by} فقرة لفت الانتباه الخاصة بإعادة العرض في {at}.",
        declinedReason: "السبب: {reason}",
        offerAgain: "اقتراحها مجددًا",
        declinedToast: "رُفضت — أُزيل التنبيه. يعود إذا تغيّرت قيود إعادة العرض.",
        noteNamed: "الإيضاح {n} — {title}",
      },
      send: {
        saveFailed: "لم يُحفظ الصف، لذلك لم يُرسل: {msg}",
        savingFirst: "جارٍ حفظ الصف أولاً…",
      },
    },
  },
};

export default I18N_S11D1B;
